import { render, staticRenderFns } from "./ListWebinars.vue?vue&type=template&id=6d2a633d&"
import script from "./ListWebinars.vue?vue&type=script&lang=js&"
export * from "./ListWebinars.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports